export default __webpack_public_path__ + "static/media/Bakery  Pastry - Breakfast 2 1.705ae346.png";